import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { signOut } from '../../supabase/auth';
import { FaSignInAlt, FaUserCircle } from 'react-icons/fa';
import logo from '../../assets/images/logo.png';

const Navbar = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      // Handle error silently or show user-friendly message
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 py-2.5 w-full">
      <div className="max-w-screen-xl mx-auto px-4 flex justify-between items-center">
        <Link to="/" className="flex items-center text-gray-800 font-bold text-xl">
          <img src={logo} alt="Nur Hidayah Press Logo" className="h-10 mr-3" />
          <span>Nur Hidayah Press</span>
        </Link>
        <nav className="flex items-center gap-6">
          {currentUser ? (
            <>
              <span className="flex items-center gap-2 font-medium text-gray-700">
                <FaUserCircle className="text-gray-600" />
                Halo, {currentUser.email}
              </span>
              <button 
                onClick={handleLogout} 
                className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg transition-colors"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/" className="text-gray-600 font-medium hover:text-yellow-500 transition-colors">Beranda</Link>
              <Link to="/login" className="flex items-center gap-2 text-gray-600 font-medium hover:text-yellow-500 transition-colors">
                <FaSignInAlt />
                <span>Masuk</span>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;